module.exports = __webpack_public_path__ + "static/media/github.dfc85a33.svg";